function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Descriptions, Table, Button, Drawer, Space, Image } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import { CheckCircle } from 'react-bootstrap-icons';
import Common from './includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OrderDetailsView = function OrderDetailsView(_ref) {
  var order = _ref.order;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    settlementArrayData = _useState2[0],
    setSettlementArrayData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    drArrayData = _useState4[0],
    setDrArrayData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSettlement = _useState6[0],
    setSelectedSettlement = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedDr = _useState8[0],
    setSelectedDr = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isSettlementProofVisible = _useState0[0],
    setIsSettlementProofVisible = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDrProofVisible = _useState10[0],
    setIsDrProofVisivle = _useState10[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant (GNF)"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Commentaire"
    }),
    dataIndex: 'comment',
    key: 'comment',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Justif."
    }),
    dataIndex: 'settlement',
    key: 'settlement',
    render: function render(settlement) {
      return /*#__PURE__*/_jsx(Button, {
        type: "link",
        onClick: function onClick() {
          setSelectedSettlement(settlement);
          setIsSettlementProofVisible(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "VOIR LA PIECE"
        })
      });
    }
  }];
  var dcols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "BL "
    }),
    dataIndex: 'dr',
    key: 'dr',
    render: function render(dr) {
      return /*#__PURE__*/_jsx(Button, {
        type: "link",
        onClick: function onClick() {
          setSelectedDr(dr);
          setIsDrProofVisivle(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "VOIR LE BL"
        })
      });
    }
  }];
  useEffect(function () {
    setSettlementArrayData([]);
    setDrArrayData([]);
    order.provider_purchase_order_settlements.forEach(function (s) {
      setSettlementArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: s.id,
          amount: s.amount,
          comment: s.comment,
          date: s.created_at,
          settlement: s
        }]);
      });
    });
    order.provider_purchase_order_delivery_reports.forEach(function (dr) {
      setDrArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: dr.id,
          date: dr.created_at,
          dr: dr
        }]);
      });
    });
  }, [order]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 9,
          children: [/*#__PURE__*/_jsxs(Descriptions, {
            bordered: true,
            title: /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs("b", {
                children: ["COMMANDE N\xBA", order.id, " DU ", /*#__PURE__*/_jsx(Moment, {
                  date: order.created_at,
                  format: "DD/MM/YYYY"
                })]
              })
            }),
            extra: order.status == 0 && /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Button, {
                type: "link",
                style: {
                  color: '#85D58C'
                },
                onClick: function onClick() {
                  handleOrderValidate(order);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "VALIDER"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "link",
                style: {
                  color: '#CA5656'
                },
                onClick: function onClick() {
                  handleOrderInvalidate(order);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "ANNULER"
                })
              })]
            }),
            column: 2,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Fournisseur"
              }),
              children: order.provider.label
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "PDV"
              }),
              children: order.point_of_sale.label
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Montant total"
              }),
              children: [order.total_amount.toLocaleString('Fr'), " GnF"]
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Montant Pay\xE9"
              }),
              children: [order.paid_amount.toLocaleString('Fr'), " GnF"]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "HISTORIQUE PAIEMENTS"
            })
          }), /*#__PURE__*/_jsx(Table, {
            bordered: true,
            size: "small",
            pagination: false,
            columns: cols,
            dataSource: settlementArrayData
          })]
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 4,
          md: 3,
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "HISTORIQUE LIVRAISONS"
            })
          }), /*#__PURE__*/_jsx(Table, {
            bordered: true,
            size: "small",
            pagination: false,
            columns: dcols,
            dataSource: drArrayData
          })]
        })]
      })
    }), selectedSettlement != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "PIECE JUSTIFICATIVE"
        }),
        width: "380px",
        open: isSettlementProofVisible,
        onClose: function onClose() {
          setIsSettlementProofVisible(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(Image, {
          src: selectedSettlement.proof,
          style: {
            width: '95%'
          }
        })
      })
    }), selectedDr != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "BON DE LIVRAISON"
      }),
      width: "380px",
      open: isDrProofVisible,
      onClose: function onClose() {
        setIsDrProofVisivle(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(Image, {
        src: Common.baseUrl + selectedDr.proof,
        style: {
          width: '95%'
        }
      })
    })]
  });
};
export default OrderDetailsView;